// src/components/myteconstruction/auth/ResetPasswordPage.js
import React, { useState } from 'react';
import axios from 'axios';
import { useSearchParams } from 'react-router-dom';

function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [newPassword, setNewPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleReset() {
    setLoading(true);
    setMessage('');
    setError('');
    try {
      const res = await axios.post('/api/myteconstruction/auth/reset', {
        token,
        newPassword
      });
      setMessage(res.data.message);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to reset password');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-4 text-white">
      <div className="max-w-md w-full bg-gray-900 p-6 rounded-lg shadow-md">
        <h2 className="text-xl font-bold mb-4 text-center">Reset Password</h2>

        {message && <div className="text-green-400 mb-3">{message}</div>}
        {error && <div className="text-red-500 mb-3">{error}</div>}

        <label className="block text-sm font-medium text-gray-300 mb-1">
          New Password
        </label>
        <input
          type="password"
          className="mb-4 p-2 w-full rounded bg-gray-800 border border-gray-700 focus:outline-none"
          placeholder="Enter new password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />

        <button
          onClick={handleReset}
          disabled={loading}
          className="w-full py-2 bg-blue-600 rounded hover:bg-blue-700 disabled:opacity-50 font-semibold"
        >
          {loading ? 'Resetting...' : 'Submit'}
        </button>
      </div>
    </div>
  );
}

export default ResetPasswordPage;
